/* global LANG */

import formatPrice from '../helpers/formatPrice';
import dataLayerHelper from '../helpers/dataLayer';

const $changeTable = $('.js-change-table');
const $actions = $('.js-change-actions');
const $diffRow = $('.js-change-diff');
const $submit = $('.js-change-submit');

const QUANTITY_CLASS = '.js-change-quantity';
const TRIGGER_CLASS = '.js-change-trigger';

const changeTable = {
  initialize() {
    if ($changeTable.length) {
      this.initialNumberOfItems = this.numberOfItems();
      this.createEvents();
    }
  },

  /**
   * Create all event listeners related to the change of an order
   * @return {void}
   */
  createEvents() {
    // Listen for clicks on the edit button
    $changeTable.on('click', TRIGGER_CLASS, (e) => {
      const $item = $(e.currentTarget);
      this.toggleChangeQuantity($item);
    });

    $changeTable.on('blur', 'input[type="number"]', (e) => {
      const $el = $(e.currentTarget);
      const min = typeof $el.attr('min') !== 'undefined' ? parseInt($el.attr('min'), 10) : 0;
      if ($el.val() < min) {
        $el.val(min).trigger('change');
      }
    });

    // Listen for order changes submit
    $submit.on('click', () => {
      const eventVal = (typeof this.diff !== 'undefined') ? this.diff : 0;
      dataLayerHelper.event('Order change', 'submit', window.location.href, eventVal);
    });

    $(document).on('change:quantity', (e, $btn) => {
      this.toggleChangeQuantity($($btn), true);
    });

    // Listen for updates from the cart module
    $(document).on('cart:change', (e, newTotal) => {
      this.toggleSaveActions(this.checkItemsChanges());
      this.outputPriceDiff(this.getPriceDiff(newTotal));
    });
  },

  /**
   * Toggle the editing of quantities for a product
   * @param {Object} $item Clicked trigger
   * @return {void}
   */
  toggleChangeQuantity($item, forceOpen = false) {
    const $parent = $item.parent();
    const $quantity = $parent.find(QUANTITY_CLASS);
    const isReadonly = forceOpen || $quantity.prop('readonly');

    // Toggle the readonly state
    $quantity.prop('readonly', !isReadonly);

    // Focus on the input field if we're going to edit
    (isReadonly ? $quantity : $item).focus();

    // Change the trigger text
    $item.text(isReadonly ? LANG.changeOrder.disable_edit : LANG.changeOrder.edit);

    // Reset the input value if we've received a cancellation
    if (!isReadonly) {
      $quantity.val($quantity.data('initial')).trigger('change');
    }
  },

  /**
   * Check if an item/row has changed (quantity is not the same as it was)
   * @param {Node} item
   * @return {Boolean}
   */
  checkItemChange(item) {
    const $quantity = $(item).find(QUANTITY_CLASS);
    const val = parseInt($quantity.val(), 10);
    const initial = parseInt($quantity.data('initial'), 10);

    return (val !== initial);
  },

  /**
   * Check if any of the items in the order has changed
   * @return {Boolean}
   */
  checkItemsChanges() {
    const $items = $changeTable.find('.js-change-item');

    // If there's a persons error open we always return false, because
    // the user isn't be able to continue
    if ($('.js-cart-persons-error').is(':visible')) {
      return false;
    }

    const numberOfItems = this.numberOfItems();

    if (numberOfItems !== this.initialNumberOfItems) {
      return true;
    }

    // Check if any of the items has changed
    return $items.toArray().reduce((acc, item) => (
      this.checkItemChange(item) ? true : acc
    ), false);
  },

  numberOfItems() {
    return $changeTable.find('.cart-item').length;
  },

  /**
   * Toggle the actions block
   * @param {Boolean} state
   * @return {void}
   */
  toggleSaveActions(state) {
    $actions.toggle(state);
  },

  /**
   * Get the difference in order price compared to what it was initially
   * @param {Number} newTotal The current price
   * @return {Number}
   */
  getPriceDiff(newTotal) {
    const initialTotal = parseFloat($changeTable.data('initial'));
    return newTotal - initialTotal;
  },

  /**
   * Output the price difference to the user
   * @param {Number} diff Price difference in comparison to the initial order value
   * @return {void}
   */
  outputPriceDiff(diff) {
    this.diff = diff;

    const $price = $diffRow.find('.js-change-diff-price');
    const $label = $diffRow.find('.js-change-diff-label');

    $diffRow.show();

    $label.attr('colspan', 1);
    $price.show();

    // We keep the difference row hidden because there's no price change
    if (diff === 0) {
      $label.text(LANG.changeOrder.nothing_to_pay).attr('colspan', 2);
      $price.text('').hide();
      return;
    }

    // Output the price difference
    $price.html(formatPrice(diff));

    // Change the label based on the fact that a price difference could be
    // below zero (user receives cash) or above (user has to pay extra)
    $label.html(diff < 0 ? LANG.changeOrder.receive : LANG.changeOrder.to_pay);

    // Change the button text with the same logic as the line above
    $submit.find('span').text(diff < 0 ? LANG.changeOrder.receive_btn : LANG.changeOrder.to_pay_btn);
  },
};

export default changeTable;
